var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3595 11.4992L15.2926 5.86561L15.973 5.13281L22.973 11.6328L23.3676 11.9992L22.973 12.3656L15.973 18.8656L15.2926 18.1328L21.3595 12.4992L0.632812 12.4992V11.4992L21.3595 11.4992Z",
    fill: "currentColor"
  })));
};

export default __webpack_public_path__ + "static/media/arrow_large.77626661.svg";
export { SvgComponent as ReactComponent };